import deDE from './de-DE'

export default {
  'de-DE': deDE
}
